export var COACH_AI_ROUTE = '/coach-ai';
export var PLATFORM_ANNOUNCEMENTS_ROUTE = '/platform-announcements';